import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/query-client';
import AppContent from './components/AppContent';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppContent />
    </QueryClientProvider>
  );
}

export default App;
